const HUB_TABS = ["overview", "training", "activity", "development", "health"]
const HEALTH_DESTINATIONS = ["sleepSeconds", "heartRate", "steps", "activeEnergyKilocalories", "totalEnergyKilocalories", "distanceMeters", "weightKilograms", "body", "activities", "settings"]

export function customerHubTab(query = {}) {
  if (HUB_TABS.includes(query.tab)) return query.tab
  if (query.health === "1") return "health"
  return query.updated === "true" || query.refresh ? "training" : "overview"
}

export function customerHubHealthMetric(value) { return HEALTH_DESTINATIONS.includes(value) ? value : "" }

export function customerHubHealthLocation(metric = "", date = "") {
  const query = { tab: "health", mode: "own" }
  const key = customerHubHealthMetric(metric), day = customerHubDate(date)
  if (key) query.metric = key
  if (day) query.date = day
  return { path: "/workout/hub", query }
}

export function customerHubDevelopmentLocation(metric, date = "") {
  const key = customerHubHealthMetric(metric)
  const topic = { steps: "movement", distanceMeters: "movement", activeEnergyKilocalories: "movement", totalEnergyKilocalories: "movement", sleepSeconds: "recovery", heartRate: "recovery", weightKilograms: "body" }[key]
  if (!topic) return customerHubHealthLocation(metric, date)
  const query = { tab: "development", topic, metric: key, period: "week", mode: "own" }
  const day = customerHubDate(date)
  if (day) query.date = day
  return { path: "/workout/hub", query }
}

export function customerHubDate(value) {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return ""
  const date = new Date(`${value}T12:00:00Z`)
  return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === value ? value : ""
}

export function customerHubPeriod(value) { return ["week", "month", "year", "all"].includes(value) ? value : "month" }

export function customerHubActivitySelection(query = {}) {
  return { date: customerHubDate(query.date), view: query.view === "history" ? "history" : "day",
    period: customerHubPeriod(query.period), filter: query.filter === "visits" ? "visits" : "training" }
}

export function customerHubActivityLocation(date, options = {}) {
  const query = { tab: "activity", mode: "own" }
  const validDate = customerHubDate(date)
  if (validDate) query.date = validDate
  if (options.view === "history") {
    query.view = "history"
  }
  if (options.view === "history" || options.period) query.period = customerHubPeriod(options.period)
  if (options.filter === "visits") query.filter = "visits"
  return { path: "/workout/hub", query }
}
